
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationConfig } from './confirmation.types';

@Component({
  selector: 'confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationConfig,
    public matDialogRef: MatDialogRef<ConfirmationComponent>
  ) {

  }
  // eslint-disable-next-line @typescript-eslint/member-ordering
  size: number;
  ngOnInit(): void {
    this.size = this.data.icon.size;
  }


}
